const objectPath = require('object-path')

const isTemplateFunction = (template) => typeof(template) === 'object' && typeof(template.function) === 'string'

const isSlotBlocked = (slot) => {
  if(!slot) return false
  return slot._blocked ?
    slot._blocked.value :
    false
}

const isSlotAdminOnly = (slot) => {
  if(!slot) return false
  return slot._admin_only ?
    slot._admin_only.value :
    false
}

const getDeepValue = (config, path, def) => objectPath.get(config, path, def)

module.exports = {
  isTemplateFunction,
  isSlotBlocked,
  isSlotAdminOnly,
  getDeepValue,
}